'use strict';

var axios = require('axios');

var $contentOverlay = $("#contact-overlay");
var $contactForm = $("#contact-form");
var $errors = $contactForm.find(".errors");
var $success = $contactForm.find(".success");

$.fn.serializeObject = function() {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

function handleContactOpener(evt) {
    evt.preventDefault();
    $contentOverlay.addClass('open');
}

var handleContactFormSubmit = function handleContactFormSubmit(evt) {
    evt.preventDefault();

    $errors.addClass('hide');
    $success.addClass('hide')

    var data = $contactForm.serializeObject();
    data._token = $('meta[name="csrf_token"]').attr('content');

    window.ga('send', {
        hitType: 'event',
        eventCategory: 'Contact Me',
        eventAction: 'Form Submit'
    });

    axios.post('/contact-us', data, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(handleSuccess)
        .catch(handleError);

};

function handleSuccess() {
    $success.removeClass('hide');
    $success.text('Your message has been sent successfully! Expect a reply in 1-2 business days.');
}

function handleError(error) {
    let html = '';

    $errors.removeClass('hide');

    if (error.response.status === 422) {
        for (let name in error.response.data.errors) {
            if (error.response.data.errors.hasOwnProperty(name)) {
                html += createErrorElem(error.response.data.errors[name]);
            }
        }
    } else {
        html += createErrorElem('An unknown error occurred. Please email larry.laski@gmail.com for support.');
    }

    $errors.html(html);
}

function createErrorElem(error) {
    return '<li class="error"><i class="fa fa-exclamation-triangle"></i>' + error + '</li>';
}

module.exports = function() {
    $('.contact-opener').on('click', handleContactOpener);
    $contactForm.on('submit', handleContactFormSubmit);
};



// WEBPACK FOOTER //
// ./resources/js/components/contact.js